import React, { Component, useMemo } from "react";
import DataTable from "../_Components/DataTable";
import SplitNumber from "../_Components/SplitNumber";
import SwalMessage from "../_Components/SwalMessage";
import { Badge } from "react-bootstrap";
import _ from "lodash";
import ApiUserManager from "../../../core/api/api.userManager";
import Switch from "@mui/material/Switch";

function DataGrid({ data, callBack, setShowTransform, setValue }) {
  const handleChange = (name) => (event) => {
    callApiService(name);
  };

  async function callApiService(item) {
    const response = await ApiUserManager.updateUserActive({ id: item.id, active: !item.active });
    if (response.succeeded == true) document.getElementById("submitButton").click();

    SwalMessage({ title: response.message, iSsuccess: response.succeeded });
  }

  const columns = useMemo(
    () => [
      //   {
      //     accessor: "_id",
      //     Header: "#",
      //     minWidth: 50,
      //   },
      {
        accessor: "userName",
        Header: "نام کاربری",
        minWidth: "100px",
      },
      {
        accessor: "firstName",
        Header: "نام",
        minWidth: "100px",
      },
      {
        accessor: "lastName",
        Header: "نام خانوادگی",
        minWidth: "100px",
      },
      {
        accessor: "phoneNumber",
        Header: "موبایل",
        minWidth: "100px",
      },
      {
        accessor: "email",
        Header: "ایمیل",
        minWidth: "100px",
      },
      {
        Header: "تایید ایمیل",
        minWidth: "100px",
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {row.original.emailConfirmed ? (
              <Badge className="text-success bg-light-success" pill>
                فعال
              </Badge>
            ) : (
              <Badge className="text-danger bg-light-danger" pill>
                غیرفعال
              </Badge>
            )}
          </div>
        ),
      },
      {
        Header: "تایید تلفن همراه",
        minWidth: "130px",
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {row.original.phoneNumberConfirmed ? (
              <Badge className="text-success bg-light-success" pill>
                فعال
              </Badge>
            ) : (
              <Badge className="text-danger bg-light-danger" pill>
                غیرفعال
              </Badge>
            )}
          </div>
        ),
      },
      {
        Header: "فعال",
        minWidth: "100px",
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            <Switch
              checked={row.original.active ? true : false}
              //checked={state.checkedA}
              value="row.original.active"
              color="primary"
              inputProps={{ "aria-label": "primary checkbox" }}
              onChange={handleChange(row.original)}
            //onChange={changeActive(row.original.id)}
            />
          </div>
        ),
      },
      {
        accessor: "lastLoginDate",
        Header: "آخرین ورود",
        minWidth: "100px",
      },
      {
        accessor: "createdPersianTime",
        Header: "زمان ایجاد",
        minWidth: "100px",
      },
      {
        Header: "موجودی کیف پول",
        minWidth: "130px",
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            <SplitNumber number={row.original.walletRiallBalance}></SplitNumber>
          </div>
        ),
      },
      {
        Header: "موجودی اعتباری",
        minWidth: "130px",
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            <SplitNumber number={row.original.creditBalance}></SplitNumber>
          </div>
        ),
      },
      {
        Header: "عملیات",
        accessor: "action",
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {/* تبدیل موجودی های کاربر  */}
            <button
              className="btn btn-light-success btn-sm mr-2 btn-icon"
              title="تبدیل موجودی"
              onClick={() => {
                setShowTransform({
                  creditBalance: row.original.creditBalance,
                  walletRiallBalance: row.original.walletRiallBalance,
                  firstName: row.original.firstName,
                  lastName: row.original.lastName,
                  userName: row.original.userName,
                  phoneNumber: row.original.phoneNumber,
                })
                setValue("userId", row.original.id)
              }}
            >
              <i className="fas fa-money-bill-transfer text-small"></i>
            </button>
            {/* مشاهده  */}
            <button
              className="btn btn-light-info btn-sm mr-2 btn-icon"
              title="نمایش اطلاعات"
              onClick={sendIdToParent(row.original)}
            >
              <i className="far fa-eye text-small"></i>
            </button>
          </div>
        ),
      },
    ],
    [],
  );

  // =======================send onject to parent component ===============
  const sendIdToParent = (index) => (event) => {
    callBack(index);
  };

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
